import { API } from 'aws-amplify';
import { push } from 'connected-react-router';

import { authorizeCurrentUser } from './auth';
import { errorActions } from './errors';
import { usersConstants } from './types';

export const usersActions = {
    updateState,
    getUsers,
    createUser,
    getUser,
    updateUser,
    remove,
    resetUser,
    toggleEnabled,
    resetPassword,
};

function updateState(name, value) {
    return { type: usersConstants.UPDATE_STATE, name, value };
}

function resetUser() {
    return { type: usersConstants.RESET_USER };
}

function getUsers() {
    return dispatch => {
        authorizeCurrentUser().then(({ currentSession }) => {
            dispatch(request());

            API.get('adminUsersAPI', '/users', {})
                .then(response => {
                    dispatch(success(response));
                })
                .catch(error => dispatch(failure(error)));
        });
    };

    function request() {
        return { type: usersConstants.LIST_REQUEST };
    }
    function success(users) {
        return { type: usersConstants.LIST_SUCCESS, users };
    }
    function failure(error) {
        return { type: usersConstants.LIST_FAIL, error };
    }
}

function createUser(user, resetUser) {
    return dispatch => {
        authorizeCurrentUser().then(({ currentSession }) => {
            dispatch(request(user));
            dispatch(errorActions.clear());

            const payload = Object.assign({}, user);
            payload.username = user.email;
            if (resetUser === true) payload.resetUser = true;

            API.post('adminUsersAPI', '/users', {
                body: payload,
            })
                .then(response => {
                    dispatch(success(response['User']));
                    dispatch(push('/users'));
                })
                .catch(error => {
                    dispatch(failure(error.response.data));
                    dispatch(errorActions.push(error.response.data));
                });
        });
    };

    function request(data) {
        return { type: usersConstants.CREATE_REQUEST, data };
    }
    function success(user) {
        return { type: usersConstants.CREATE_SUCCESS, user };
    }
    function failure(error) {
        return { type: usersConstants.CREATE_FAIL, error };
    }
}

function getUser(id) {
    return dispatch => {
        authorizeCurrentUser().then(({ currentSession }) => {
            dispatch(request(id));
            dispatch(errorActions.clear());

            API.get('adminUsersAPI', `/users/${id}`, {})
                .then(response => response[0])
                .then(user => dispatch(success(user)))
                .catch(error => dispatch(failure(error)));
        });
    };

    function request(id) {
        return { type: usersConstants.GET_REQUEST, id };
    }
    function success(user) {
        return { type: usersConstants.GET_SUCCESS, user };
    }
    function failure(error) {
        return { type: usersConstants.GET_FAIL, error };
    }
}

function updateUser(user) {
    return dispatch => {
        authorizeCurrentUser().then(({ currentSession }) => {
            dispatch(request(user));
            dispatch(errorActions.clear());

            API.put('adminUsersAPI', `/users/${user.id}`, {
                body: user,
            })
                .then(response => {
                    dispatch(success(response));
                    dispatch(push('/users'));
                })
                .catch(error => {
                    dispatch(failure(error));
                    dispatch(errorActions.push(error.response.data));
                });
        });
    };

    function request(user) {
        return { type: usersConstants.SAVE_REQUEST, user };
    }
    function success(user) {
        return { type: usersConstants.SAVE_SUCCESS, user };
    }
    function failure(error) {
        return { type: usersConstants.SAVE_FAIL, error };
    }
}

function remove(user) {
    return dispatch => {
        authorizeCurrentUser().then(({ currentSession }) => {
            dispatch(request(user));
            dispatch(errorActions.clear());

            API.del('adminUsersAPI', `/users/${user.id}`, {})
                .then(response => {
                    dispatch(success());
                    dispatch(push('/users'));
                })
                .catch(error => dispatch(failure(error)));
        });
    };

    function request(user) {
        return { type: usersConstants.DELETE_REQUEST, user };
    }
    function success() {
        return { type: usersConstants.DELETE_SUCCESS };
    }
    function failure(error) {
        return { type: usersConstants.DELETE_FAIL, error };
    }
}

function toggleEnabled(user, enabled) {
    return dispatch => {
        authorizeCurrentUser().then(({ currentSession }) => {
            dispatch(request(user));
            dispatch(errorActions.clear());

            API.put('adminUsersAPI', `/users/${user.id}/toggle`, {
                body: {
                    enabled: enabled,
                },
            })
                .then(response => {
                    dispatch(success(user, enabled));
                })
                .catch(error => dispatch(failure(error)));
        });
    };

    function request(user) {
        return { type: usersConstants.TOGGLE_ENABLED_REQUEST, user };
    }
    function success(user, enabled) {
        return { type: usersConstants.TOGGLE_ENABLED_SUCCESS, user, enabled };
    }
    function failure(error) {
        return { type: usersConstants.TOGGLE_ENABLED_FAIL, error };
    }
}

function resetPassword(user) {
    return dispatch => {
        authorizeCurrentUser().then(({ currentSession }) => {
            dispatch(request(user));
            dispatch(errorActions.clear());

            API.put('adminUsersAPI', `/users/${user.id}/reset`, {})
                .then(response => {
                    dispatch(success(user));
                })
                .catch(error => dispatch(failure(error)));
        });
    };

    function request(user) {
        return { type: usersConstants.RESET_PASSWORD_REQUEST, user };
    }
    function success(user, enabled) {
        return { type: usersConstants.RESET_PASSWORD_SUCCESS, user };
    }
    function failure(error) {
        return { type: usersConstants.RESET_PASSWORD_FAIL, error };
    }
}
